// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__Ft_MK","title":"Login_title__m0fmv","chooseLoginType":"Login_chooseLoginType__B_qhd"};